import { AcceleratedUnderline } from "../../../../../assets/icons/AcceleratedUnderline";
import bnbChain from "../../../../../assets/membersLogos/bnbChain.png";
import Coinmarketcap from "../../../../../assets/membersLogos/CoinMarketCap.png";
import YZILabs from "../../../../../assets/membersLogos/yZiLabs.png";
import React from "react";

interface AcceleratedByProps {
  mvbLogoSrc?: string;
  bnbChainLogoSrc?: string;
  coinMarketCapLogoSrc?: string;
  yziLabsLogoSrc?: string;
}
const buttonShadow = `shadow-[0px_0.14vw_0.28vw_rgba(0,0,0,0.05)] max-lg:shadow-[0px_0.53vw_1.06vw_rgba(0,0,0,0.05)]`;

const buttonGradient = `relative before:content-[''] before:absolute before:inset-0 before:p-[0.07vw]
 before:rounded-[6.94vw] before:[background:linear-gradient(101.62deg,#FFFFFF_0%,rgba(255,255,255,0)_100%)] 
 before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] before:[-webkit-mask-composite:xor]
  before:[mask-composite:exclude] before:pointer-events-none before:z-[1]`;

export const AcceleratedBy: React.FC<AcceleratedByProps> = () => {
  return (
    <div className="relative z-10 flex justify-center">
      <div className={`w-full max-w-[56.875vw] max-lg:max-w-[90vw]`}>
        <div className="flex items-start gap-[1.66vw]  max-lg:gap-[6.4vw] ">
          <div className="flex flex-col items-start gap-[0.83vw] max-lg:gap-[2.13vw] flex-1">
            <div className="inline relative z-0">
              <p className="text-black font-[400] text-[1.67vw] leading-[110%] max-lg:text-[4.8vw]">
                MVB10 member, accelerated by
              </p>
              <AcceleratedUnderline
                className="absolute bottom-[-5%]  max-lg:h-auto
               w-[24.44vw] max-lg:w-[70.4vw] h-auto  z-[-2] left-1/2 -translate-x-1/2"
              />
            </div>{" "}
            <div className="flex flex-wrap gap-[0.69vw] max-lg:gap-[1.1vw]">
              <AcceleratorButton
                label="BNB CHAIN"
                responsiveHeight="h-[1.39vw] max-lg:h-[3.85vw]"
                textColor=" py-[0.63vw] px-[0.76vw]  max-lg:px-[2.13vw]"
                logoSrc={bnbChain}
              />
              <AcceleratorButton
                label="CoinMarketCap"
                responsiveHeight="h-[1.81vw] max-lg:h-[5.02vw]"
                textColor="py-[0.42vw] px-[0.76vw]  max-lg:px-[2.13vw]"
                logoSrc={Coinmarketcap}
              />
              <AcceleratorButton
                label="YZiLabs"
                responsiveHeight="h-[1.59vw] max-lg:h-[4.45vw]"
                textColor="py-[0.42vw] px-[0.76vw]  max-lg:px-[2.13vw]"
                logoSrc={YZILabs}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

interface AcceleratorButtonProps {
  label: string;
  responsiveHeight: string;
  textColor: string;
  logoSrc?: string;
}

const AcceleratorButton: React.FC<AcceleratorButtonProps> = ({
  label,
  responsiveHeight,
  textColor,
  logoSrc,
}) => (
  <div className={buttonGradient}>
    <button
      className={`
      flex items-center  justify-center 
      rounded-[6.94vw] max-lg:rounded-[26.67vw] font-medium text-[0.83vw] max-lg:text-[3.2vw] leading-[1.11vw] max-lg:leading-[4.27vw] bg-[#E9EBF3]
      ${buttonShadow} h-[2.78vw] max-lg:h-[7.47vw]
      ${textColor}
    `}
    >
      {responsiveHeight && (
        <img src={logoSrc} alt={`${label} Logo`} className={responsiveHeight} />
      )}
    </button>
  </div>
);
